import { endpoints } from "@/utils/common/requests/endpoints";
import { useAction } from "@/utils/useQuery/useAction";

/**
 * @typedef {Object} UpdateCrewNameArg
 * @property {string} crewId
 * @property {Object} payload
 */

/**
 * @returns {import("@/utils/useQuery/useAction").ActionReturn<UpdateCrewNameArg>}
 */
export function useUpdateCrewName() {
	return useAction({
		url: (arg) => endpoints.crew.UPDATE_NAME(arg.crewId),
		method: "patch",
	});
}
